var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"biaozhu-wrap"}},[_c('div',{staticStyle:{"display":"none"}},[_c('div',{ref:"lywindow"},[_vm._t("window")],2)]),_vm._v(" "),_c('div',{attrs:{"id":"biaozhu"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d90bd44","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map20/locate.vue
// module id = null
// module chunks = 